import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

const Reviews = () => {
	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.up("md"), {
		defaultMatches: true,
	});

	return (
		<Box>
			<Box marginBottom={4}>
				<Box
					component={Typography}
					fontWeight={700}
					variant="h3"
					align="center"
					gutterBottom>
					Loved by the biggest franchise
					<br />
					brands across the globe.
				</Box>

				<Box
					display="flex"
					flexWrap="wrap"
					justifyContent="center"
					alignItems="center">
					{[
						"/new-mangomap-assets/svg/bfa.svg",
						"/new-mangomap-assets/svg/anytimefitness.svg",
						"/new-mangomap-assets/svg/foreverlawn.svg",
						"/new-mangomap-assets/svg/rams.svg",
						"/new-mangomap-assets/svg/kellerwilliam.svg",
						"/new-mangomap-assets/svg/aussie.svg",
						"/new-mangomap-assets/svg/sourcebulkfoods.svg",
						"/new-mangomap-assets/svg/carpetcourt.svg",
						"/new-mangomap-assets/svg/littlelearners.svg",
						"/new-mangomap-assets/svg/stumpy.svg",
					].map((item, i) => (
						<Box
							maxWidth={180}
							marginTop={2}
							marginRight={4}
							key={i}
							data-aos={isMd ? "fade-right" : "fade-up"}>
							<Box
								component="img"
								width="100%"
								src={item}
								alt="..."
								sx={{
									filter:
										theme.palette.mode === "dark"
											? "brightness(0) invert(1)"
											: "none",
								}}
							/>
						</Box>
					))}
				</Box>
			</Box>

			<Grid
				container
				spacing={2}>
				{[
					{
						feedback:
							"Mango does a great job of providing the outline of territories and having the ability to search through zip code.",
						name: "Lauren Aten",
						title: "Dealer Support, ForeverLawn",
						avatar: "/new-mangomap-assets/images/lauren.jpeg",
					},
					{
						feedback:
							"I found Mango to be the best option for us. I like how user-friendly it is. The ability for my regional partners & potential candidates to log in is very helpful. All in all, I’m very happy with the software!",
						name: "Jarrad Goulding",
						title: "Founder, The Local Guys",
						avatar: "/new-mangomap-assets/images/jarrad.jpeg",
					},
					{
						feedback:
							"Easy to setup, GREAT support team that responded quickly early on and then the tool itself was very easy to use and produced desired results. This is how software should be. Legit!",
						name: "David Ranallo",
						title: "Balanced Family Academy",
						avatar: "/new-mangomap-assets/images/bfaicon.png",
					},
				].map((item, i) => (
					<Grid
						item
						xs={12}
						md={4}
						key={i}>
						<Box
							width="100%"
							height="100%"
							data-aos="fade-up"
							component={Card}
							display="flex"
							flexDirection="column"
							boxShadow={0}>
							<Box
								component={CardContent}
								display="flex"
								flexDirection="column"
								alignItems="flex-start">
								<Box
									marginBottom={1}
									display="flex">
									{[1, 2, 3, 4, 5].map((item) => (
										<Box
											key={item}
											color={theme.palette.secondary.main}>
											<svg
												width={18}
												height={18}
												xmlns="http://www.w3.org/2000/svg"
												viewBox="0 0 20 20"
												fill="currentColor">
												<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
											</svg>
										</Box>
									))}
								</Box>
								<Typography
									align="left"
									color="textSecondary">
									{item.feedback}
								</Typography>
							</Box>
							<Box flexGrow={1} />
							<CardActions>
								<ListItem
									component="div"
									disableGutters
									sx={{ padding: 0 }}>
									<ListItemAvatar>
										<Avatar src={item.avatar} />
									</ListItemAvatar>
									<ListItemText
										sx={{ margin: 0 }}
										primary={item.name}
										secondary={item.title}
									/>
								</ListItem>
							</CardActions>
						</Box>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default Reviews;
